module.exports = __webpack_public_path__ + "static/img/data_line_red.d2e2f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/data_line_red.png
// module id = ovp+
// module chunks = 2